import { useMutation } from '@tanstack/react-query';

import type { Capacity } from '~/consts/capacities';

import ReservationService from '~/services/ReservationService';
import { HttpResponse } from '~/services/types';

export interface CreateRoomTypeCapacityParams {
  capacity: Capacity;
  propertyId: string;
  roomRateId: string;
  roomTypeId: string;
}

export function useCreateRoomTypeCapacity() {
  return useMutation({
    mutationFn: ({
      capacity,
      propertyId,
      roomRateId,
      roomTypeId,
    }: CreateRoomTypeCapacityParams): Promise<HttpResponse<Capacity>> =>
      ReservationService.createRoomTypeCapacity(capacity, propertyId, roomTypeId, roomRateId) as Promise<
        HttpResponse<Capacity>
      >,
  });
}
